import { Store, createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { StoreState } from '.';
import rootReducer from '../reducers/index';

export default function configureStoreProd(): Store<StoreState> {
    return createStore<StoreState>(
        rootReducer,
        applyMiddleware(thunk)
    );
}



// WEBPACK FOOTER //
// ./src/store/configureStore.prod.ts